import { PersonalizeType } from '@portalCommon/constants';

export const SIDE_LIST = [
  {
    key: PersonalizeType.Cloth,
    text: '服装',
    unSelect: 'https://static.fuxi.netease.com/yaotai/portal/index/lfaqerk4_201730.png',
    selected: 'https://static.fuxi.netease.com/yaotai/portal/index/lfaqemfn_195089.png',
  },
  {
    key: PersonalizeType.Hair,
    text: '发型',
    unSelect: 'https://static.fuxi.netease.com/yaotai/portal/index/lfaqerk3_201730.png',
    selected: 'https://static.fuxi.netease.com/yaotai/portal/index/lfaqemfm_195089.png',
  },
  {
    key: PersonalizeType.Face,
    text: '捏脸',
    unSelect: 'https://static.fuxi.netease.com/yaotai/portal/index/lfaqerk5_201730.png',
    selected: 'https://static.fuxi.netease.com/yaotai/portal/index/lfaqemfo_195089.png',
  },
  {
    key: PersonalizeType.Action,
    text: '动作',
    unSelect: 'https://static.fuxi.netease.com/yaotai/portal/index/lfaqerk2_201730.png',
    selected: 'https://static.fuxi.netease.com/yaotai/portal/index/lfaqemfl_195088.png',
  },
];
